import { API, BlockTool } from '@editorjs/editorjs';
import { buttonModal } from './ButtonModal';

interface ButtonData {
  text: string;
  link?: string;
  programmaticallyAdded?: boolean;
}

interface ButtonToolSettings {
  data?: ButtonData;
  api: API;
}

class ButtonTool implements BlockTool {
  private api: API;
  private buttonData: ButtonData;
  private button: HTMLButtonElement;
  private wrapper: HTMLDivElement;

  constructor({ data, api }: ButtonToolSettings) {
    this.api = api;
    this.buttonData = data || { text: '' };
    this.wrapper = document.createElement('div');

    this.button = this.createButton(this.buttonData.text || 'Click me');

    // If added programmatically, append button immediately
    if (this.isProgrammaticallyAdded() || this.isEmptyBlock()) {
      this.wrapper.appendChild(this.button);
    } else {
      this.promptForData();
    }
  }

  private createButton(text: string): HTMLButtonElement {
    const button = document.createElement('button');
    button.type = 'button';
    button.innerText = text;
    button.classList.add('buttonClass');
    button.addEventListener('click', this.handleClick.bind(this));
    this.setButtonStyles(button);
    return button;
  }

  private setButtonStyles(button: HTMLButtonElement) {
    Object.assign(button.style, {
      backgroundColor: 'rgba(0, 148, 145, 1)',
      minWidth: '136px',
      height: '48px',
      padding: '13px 20px',
      borderRadius: '12px',
      border: 'none',
      display: 'block',
      fontSize: '16px',
      fontFamily: 'Inter',
      fontWeight: '600',
      color: '#FFF',
      cursor: 'pointer',
    });
  }

  private isProgrammaticallyAdded(): boolean {
    return !!this.buttonData.programmaticallyAdded;
  }

  private isEmptyBlock(): boolean {
    return this.api.blocks.getBlocksCount() < 1;
  }

  private async promptForData() {
    const data = await buttonModal();

    if (data.title && data.link) {
      this.updateButton(data.title, data.link);
    }

    this.wrapper.appendChild(this.button);
  }

  private updateButton(text: string, link?: string) {
    this.buttonData.text = text;
    this.buttonData.link = link;
    this.button.innerText = text;
  }

  private handleClick() {
    if (this.buttonData.link) {
      window.open(this.buttonData.link, '_blank');
    }
  }

  render() {
    return this.wrapper;
  }

  save() {
    return {
      text: this.buttonData.text,
      link: this.buttonData.link,
    };
  }

  static get toolbox() {
    return {
      title: 'Button',
      icon: '',
    };
  }
}

export default ButtonTool;
